import React from 'react';
import { Facebook, Twitter, Instagram, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-yellow-500 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Mana Mamidipallu</h3>
            <p className="text-sm">Delivering the finest mangoes straight to your doorstep.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/about-us" className="hover:text-yellow-200">About Us</a></li>
              <li><a href="/shop" className="hover:text-yellow-200">Shop</a></li>
              <li><a href="/subscriptions" className="hover:text-yellow-200">Subscriptions</a></li>
              <li><a href="/contact" className="hover:text-yellow-200">Contact</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-2">
              <p className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <span>9550729943</span>
                <span>Vijayawada</span>
                <span>Andhra Pradesh</span>
              </p>
              <p className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <span>info@manamamidipallu.com</span>
              </p>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-yellow-200"><Facebook className="h-6 w-6" /></a>
              <a href="#" className="hover:text-yellow-200"><Twitter className="h-6 w-6" /></a>
              <a href="#" className="hover:text-yellow-200"><Instagram className="h-6 w-6" /></a>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-yellow-400">
          <p className="text-center text-sm">
            © {new Date().getFullYear()} Mana Mamidipallu. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;